import { Buttons } from './Buttons'
import { UnfUrlCard } from './UnfUrlCard'
import { ContentCard } from './ContentCard'
import { ConversationQuery } from '../../../Conversation.generated'
import { ConversationCardType } from '../../../../../../../../api/types'

type CardProps = {
  event: ConversationQuery['Conversation']['messages'][0]
}

export function Card({ event }: CardProps) {
  switch (event?.card?.type) {
    case ConversationCardType.Unfurl:
      return <UnfUrlCard event={event} />

    case ConversationCardType.Card:
      return <ContentCard event={event} />

    default:
      return <Buttons event={event} />
  }
}
